module.exports = __webpack_public_path__ + "img/bg.48d59c36.png";